import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import '../styles/HptScreens.css'; // IMPORTAMOS LA HOJA GLOBAL

const SignaturePad = ({ onSave, onCancel }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);

    // Estados de las firmas guardadas
    const [firmaGuardada, setFirmaGuardada] = useState(null);
    const [cargandoFirma, setCargandoFirma] = useState(true);

    useEffect(() => {
        const fetchFirma = async () => {
            const token = localStorage.getItem('userToken');
            if (!token) return;
            try {
                const decoded = jwtDecode(token);
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/${decoded.id}/firma`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.data.hasSignature) {
                    setFirmaGuardada(res.data.firma_path);
                }
            } catch (err) {
                console.warn("No se pudo obtener la firma guardada.");
            } finally {
                setCargandoFirma(false);
            }
        };
        fetchFirma();
    }, []);

    // Función inteligente que entiende Ratón y Dedos
    const getCoordinates = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        
        // Si es un evento táctil (dedo)
        if (e.touches && e.touches.length > 0) {
            return {
                offsetX: e.touches[0].clientX - rect.left,
                offsetY: e.touches[0].clientY - rect.top
            };
        }
        // Si es un evento de ratón
        return {
            offsetX: e.nativeEvent.offsetX,
            offsetY: e.nativeEvent.offsetY
        };
    };

    const startDrawing = (e) => {
        e.preventDefault(); // Evita que la pantalla haga scroll en móviles
        const { offsetX, offsetY } = getCoordinates(e);
        const ctx = canvasRef.current.getContext('2d');
        ctx.beginPath();
        ctx.moveTo(offsetX, offsetY);
        setIsDrawing(true);
    };

    const draw = (e) => {
        e.preventDefault(); // Evita que la pantalla haga scroll en móviles
        if (!isDrawing) return;
        const { offsetX, offsetY } = getCoordinates(e);
        const ctx = canvasRef.current.getContext('2d');
        
        // Mejoramos un poco el trazo para que parezca un boli real
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        
        ctx.lineTo(offsetX, offsetY);
        ctx.stroke();
    };

    const stopDrawing = () => setIsDrawing(false);

    const clear = () => {
        const ctx = canvasRef.current.getContext('2d');
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    };

    const handleSave = () => {
        const dataURL = canvasRef.current.toDataURL('image/png'); // Imagen en Base64
        onSave(dataURL);
    };

    const handleUsarGuardada = () => {
        if (firmaGuardada) {
            onSave(firmaGuardada);
        }
    };

    return (
        <div className="signature-overlay">
            <div className="signature-modal">
                <h3 className="signature-title">Firma Digital Autorizada</h3>
                
                {/* Botón de Firma Rápida con Estilos Limpios */}
                {!cargandoFirma && firmaGuardada && (
                    <div className="signature-saved-box">
                        <p className="signature-saved-text">Tienes una firma guardada.</p>
                        <button onClick={handleUsarGuardada} className="btn-use-saved">
                            ✍️ Usar mi Firma Guardada
                        </button>
                        <p className="signature-saved-hint">O dibuja una nueva a continuación:</p>
                    </div>
                )}

                <canvas 
                    ref={canvasRef} 
                    width={400} height={200} 
                    className="signature-canvas"
                    // Eventos de Ratón
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    // 🔌 Eventos Táctiles (Tablets/Móviles)
                    onTouchStart={startDrawing}
                    onTouchMove={draw}
                    onTouchEnd={stopDrawing}
                />
                <div className="signature-buttons">
                    <button onClick={clear} className="btn-sign-clear">Borrar</button>
                    <button onClick={onCancel} className="btn-sign-cancel">Cancelar</button>
                    <button onClick={handleSave} className="btn-sign-confirm">Confirmar Firma</button>
                </div>
            </div>
        </div>
    );
};

export default SignaturePad;